import React from 'react';
import cx from 'classnames';

import { SiteConfigManager, useEventState } from '@atlas/core';
import { Icon } from '@atlas/ui';

import { sportService } from 'common/constants';
import EventLiveStatus from 'common/Widgets/Tournament/Tournament/Events/Event/EventLiveStatus';
import EventLiveStatusWidgets from 'common/Widgets/Tournament/Tournament/Events/Event/EventLiveStatusWidgets';
import EventStartTime from 'common/Widgets/Tournament/Tournament/Events/Event/EventStartTime';
import EventStatistics from 'components/Pages/Live/EventStatistics';
import ProfitIcons from 'components/Pages/ProfitIcons';

const { LIVE, PREMATCH } = sportService;
const EventPeriodInfo = ({ scroll, swipe }) => {
  const event = useEventState();
  const { id, noneMargin, oddsBust, outcomesCount, sportService, widgets } = event;

  const showEventId = SiteConfigManager.getConfig('config.config.sportsbook.showEventId');
  const renderEventId = React.useMemo(
    () =>
      showEventId &&
      (sportService === LIVE || sportService === PREMATCH) && (
        <span className="event-info-id sub-title-xsmall-500-text">ID {id}</span>
      ),
    [id, showEventId, sportService],
  );

  const renderStatisticIcon = React.useMemo(
    () =>
      sportService === PREMATCH &&
      widgets?.some(widget => widget.type === 'STATISTIC') && (
        <div className="statistic-indicator">
          {swipe ? (
            <Icon height={18} name="statistics" width={18} />
          ) : (
            <Icon height={16} name="match-statistic" width={16} />
          )}
        </div>
      ),
    [sportService, widgets, swipe],
  );

  const tournamentEventInfoClassName = cx('event-period__info tournament-scroll-event-info-data', {
    'with-event-id': showEventId,
  });

  return (
    <div className={tournamentEventInfoClassName}>
      {scroll && (
        <div className="event-period__scroll">
          {sportService === LIVE ? (
            <>
              <EventLiveStatus />
              <EventLiveStatusWidgets widgets={widgets} />
            </>
          ) : (
            <EventStartTime />
          )}

          <EventStatistics />

          {renderStatisticIcon}
          {renderEventId}

          <span className="sub-title-xsmall-300-text outcomes-count">+{outcomesCount}</span>
        </div>
      )}
      {swipe && (
        <div className="event-period__swipe">
          {sportService === LIVE ? <EventLiveStatus /> : <EventStartTime />}
          <div className="event-period__icons">
            {renderStatisticIcon}
            <EventLiveStatusWidgets noIcons={sportService === PREMATCH} swipe widgets={widgets} />
            <EventStatistics swipe />
            <ProfitIcons noneMargin={noneMargin} oddsBust={oddsBust} />
          </div>
        </div>
      )}
    </div>
  );
};
export default EventPeriodInfo;
